import { InjectionToken } from '@angular/core';
import { AbstractFilterOption, FilterValue } from '@elio/emanager-front/shared/models';
import { Observable } from 'rxjs';

export interface FilterableType {
  id: number | string;
}

export interface FilterableStore<T extends FilterableType> {
  searchFilters$: Observable<AbstractFilterOption<T> | undefined>;
  filtersTree$: Observable<AbstractFilterOption<T> | undefined>;
  activeFiltersIds$: Observable<string[]>;
  activeFiltersSize$: Observable<number>;
  resetfilter: () => void;
  enableFilter: (filter: FilterValue<T>) => void;
  disableFilter: (filter: FilterValue<T>) => void;
}

export const FILTERABLE_STORE = new InjectionToken<FilterableStore<FilterableType>>('Filterable store');

export const FILTERS_PERSIST_ID = new InjectionToken<string>('Filters Persist Id');
